import { EventDrivenStore } from '@core/store/eventDrivenStore';
import constants from '@core/utils/constants';
import { User } from './user';
import { bus } from '@core/events/eventSystem';
import Commons from '@features/shared/libraries/commons';

class UserStore extends EventDrivenStore {
  constructor() {
    const initialState = {
      current: null,
      loading: false,
      isLoggedIn: false,
      error: null,
      otpData: null
    };
    super('user', initialState, {
      useLocalStorage: true
    });

    this.updateState({
      ...initialState,
      current: this.state.current || null,
      isLoggedIn: this.state.isLoggedIn || false
    });
  }

  async setupEvents() {
    // Écouter les données envoyées par le bridge (NativeStorage)
    window.addEventListener('message', (event) => {
      if (event.data?.type === 'RETRIEVED_USER_DATA') {
        const userData = event.data.data;
        if (userData && !this.state.current) {
          console.log('[UserStore] Restauration session via NativeStorage');
          bus.emit(constants.EVENTS.USER.LOGIN_SUCCESS, userData);
        }
      }
    });

    this.on(constants.EVENTS.USER.LOGIN, () => {
      this.state.loading = true;
      this.state.error = null;
    });

    this.on(constants.EVENTS.USER.LOGIN_SUCCESS, async (user) => {
      this.state.current = user;
      console.log("🚀 ~ UserStore ~ setupEvents ~ user:", user)
      this.state.isLoggedIn = !!this.state.current;
      this.state.error = null;
      this.state.loading = false;

      // Synchroniser avec NativeStorage si sur Capacitor
      if (Commons.isCapacitor()) {
        window.parent.postMessage({
          type: 'SYNC_USER_DATA',
          userData: user
        }, '*');
      }
    });

    this.on(constants.EVENTS.USER.LOGIN_ERROR, async (error) => {
      this.state.error = error?.message || error;
      this.state.loading = false;
      this.state.isLoggedIn = false;
    });

    this.on(constants.EVENTS.USER.REGISTER, async () => {
      this.state.loading = true;
      this.state.error = null;
    });

    this.on(constants.EVENTS.USER.REGISTER_SUCCESS, async (user) => {
      this.state.current = user;
      this.state.isLoggedIn = !!this.state.current;
      this.state.error = null;
      this.state.loading = false;

      // Synchroniser avec NativeStorage si sur Capacitor
      if (Commons.isCapacitor()) {
        window.parent.postMessage({
          type: 'SYNC_USER_DATA',
          userData: user
        }, '*');
      }
    });

    this.on(constants.EVENTS.USER.REGISTER_ERROR, async (error) => {
      this.state.error = error?.message || error;
      this.state.loading = false;
      this.state.isLoggedIn = false;
    });

    this.on(constants.EVENTS.USER.UPDATE, () => {
      this.state.loading = true;
      this.state.error = null;
    });

    this.on(constants.EVENTS.USER.UPDATE_SUCCESS, async (updatedUser) => {
      console.log('🚀 ~ UserStore ~ setupEvents ~ updatedUser:', updatedUser);
      if (updatedUser instanceof User) {
        const mergedUser = new User({
          ...this.state.current,
          ...updatedUser
        });
        this.state.current = mergedUser;
      }
      this.state.error = null;
      this.state.loading = false;

      // Synchroniser avec NativeStorage si sur Capacitor
      if (Commons.isCapacitor()) {
        window.parent.postMessage({
          type: 'SYNC_USER_DATA',
          userData: this.state.current
        }, '*');
      }
    });

    this.on(constants.EVENTS.USER.UPDATE_ERROR, async (error) => {
      this.state.error = error?.message || error;
      this.state.loading = false;
    });

    this.on(constants.EVENTS.USER.LOGOUT, async () => {
      this.updateState({ ...this.initialState });

      // Nettoyer NativeStorage si sur Capacitor
      if (Commons.isCapacitor()) {
        window.parent.postMessage({
          type: 'SYNC_USER_DATA',
          userData: null
        }, '*');
      }

      bus.emit(constants.EVENTS.SHARED.RELOAD_APP_TO_HOME);
    });
  }
}

export default UserStore;
